import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";

import {closeAppMenu} from "state/app/actions";
import {isMenuOpen} from "state/app/selectors";

import "./MainMenuTouchGuard.css";

  // Renders only when the menu is open - closes the menu on click
class MainMenuTouchGuard extends React.Component {
  render() {
    if(this.props.isMenuOpen) {
      return <div onClick={this.props.closeAppMenu} className="main-menu-touch-guard"></div>;
    } else {
      return null;
    }
  }
}


export default connect(
  (state) => ({
    isMenuOpen: isMenuOpen(state)
  }),
  (dispatch) => bindActionCreators({
    closeAppMenu
  }, dispatch)
)(MainMenuTouchGuard);



// WEBPACK FOOTER //
// ./src/components/app/MainMenuTouchGuard.js